var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"speech-container"},[(!_vm.isRecording)?_c('el-button',{attrs:{"type":"primary","icon":"el-icon-microphone","circle":""},on:{"click":_vm.startRecording}}):_c('el-button',{attrs:{"type":"info","icon":"el-icon-microphone","circle":""},on:{"click":_vm.stopRecording}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }